import { render, staticRenderFns } from "./CollapseNotificationBtn.vue?vue&type=template&id=59acf3be&"
import script from "./CollapseNotificationBtn.vue?vue&type=script&lang=js&"
export * from "./CollapseNotificationBtn.vue?vue&type=script&lang=js&"
import style0 from "./CollapseNotificationBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59acf3be')) {
      api.createRecord('59acf3be', component.options)
    } else {
      api.reload('59acf3be', component.options)
    }
    module.hot.accept("./CollapseNotificationBtn.vue?vue&type=template&id=59acf3be&", function () {
      api.rerender('59acf3be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/CollapseNotificationBtn.vue"
export default component.exports